import React from "react";
import PublicPage from "@/components/public/PublicPage";
import ConnectedPlatform from "@/components/home/ConnectedPlatform";
import PlatformFeatures from "@/components/home/PlatformFeatures";
import MultiLocationSection from "@/components/home/MultiLocationSection";

export default function PlatformPage() {
  return (
    <PublicPage
      eyebrow="One Connected Food-Safety System"
      title="The Crystal HACCP Platform"
      intro="A web dashboard for managing the food-safety system and a mobile app for completing the work. Records stay connected across both."
    >
      <ConnectedPlatform />
      <PlatformFeatures />
      <MultiLocationSection />
    </PublicPage>
  );
}
